"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var DateTimePicker_1 = __importDefault(require("../common/DateTimePicker"));
var TimeSelector_1 = __importDefault(require("../common/TimeSelector"));
var EventManagement_module_css_1 = __importDefault(require("./EventManagement.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var types_1 = require("@/Types/types");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var AddPresentationModal_1 = __importDefault(require("../Players/AddPresentationModal"));
var date_fns_1 = require("date-fns");
var uuid_1 = require("uuid");
var NewEventModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, modalMode = _a.modalMode, existingEventData = _a.existingEventData;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)([]), schedules = _b[0], setSchedules = _b[1];
    var _c = (0, react_1.useState)(""), eventName = _c[0], setEventName = _c[1];
    var _d = (0, react_1.useState)(""), eventStart = _d[0], setEventStart = _d[1];
    var _e = (0, react_1.useState)(""), eventEnd = _e[0], setEventEnd = _e[1];
    var _f = (0, react_1.useState)(modalMode === "new"), eventActive = _f[0], setEventActive = _f[1];
    var _g = (0, react_1.useState)(false), showAddPresentationModal = _g[0], setShowAddPresentationModal = _g[1];
    var _h = (0, react_1.useState)(null), selectedPresentation = _h[0], setSelectedPresentation = _h[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _j = (0, react_1.useState)(true), isValidDateRange = _j[0], setIsValidDateRange = _j[1];
    var days = (0, react_1.useMemo)(function () {
        var initials = t("day_initials", { returnObjects: true });
        return [
            { id: "1", initial: initials[0] },
            { id: "2", initial: initials[1] },
            { id: "3", initial: initials[2] },
            { id: "4", initial: initials[3] },
            { id: "5", initial: initials[4] },
            { id: "6", initial: initials[5] },
            { id: "7", initial: initials[6] }
        ];
    }, [t]);
    var resetForm = (0, react_1.useCallback)(function () {
        setEventName("");
        setEventStart("");
        setEventEnd("");
        setEventActive(modalMode === "new");
        setSchedules([]);
        setSelectedPresentation(null);
    }, [modalMode]);
    (0, react_1.useEffect)(function () {
        var format = "yyyyMMddHHmm";
        if (eventStart && eventEnd) {
            var start = (0, date_fns_1.parse)(eventStart, format, new Date());
            var end = (0, date_fns_1.parse)(eventEnd, format, new Date());
            setIsValidDateRange((0, date_fns_1.isValid)(start) && (0, date_fns_1.isValid)(end) && !(0, date_fns_1.isBefore)(end, start));
        }
        else {
            setIsValidDateRange(true);
        }
    }, [eventStart, eventEnd]);
    (0, react_1.useEffect)(function () {
        if (isShown) {
            if (modalMode === "edit" && existingEventData) {
                setEventName(existingEventData.title || "");
                setEventStart(existingEventData.start ? String(existingEventData.start) : "");
                setEventEnd(existingEventData.end ? String(existingEventData.end) : "");
                setEventActive(existingEventData.active || false);
                var parsedSchedules = existingEventData.time_schedule ? tryParseSchedules(existingEventData.time_schedule) : [];
                setSchedules(parsedSchedules);
                if (existingEventData.presentation_id) {
                    setSelectedPresentation({
                        presentation_id: existingEventData.presentation_id,
                        presentation_version_id: existingEventData.presentation_version_id,
                        presentation_title: existingEventData.presentation_name
                    });
                }
            }
            else if (modalMode === "new") {
                resetForm();
            }
        }
    }, [isShown, modalMode, existingEventData, resetForm]);
    function tryParseSchedules(scheduleData) {
        try {
            return Array.isArray(scheduleData) ? scheduleData : JSON.parse(scheduleData);
        }
        catch (error) {
            logger.error("Error parsing schedule data:", error);
            return [];
        }
    }
    var handleAddRow = function () {
        setSchedules(__spreadArray(__spreadArray([], schedules, true), [{ id: (0, uuid_1.v4)(), start: "00:00", end: "00:00", days: [] }], false));
    };
    var handleRemoveRow = function (id) {
        var newSchedules = schedules.filter(function (schedule) { return schedule.id !== id; });
        setSchedules(newSchedules);
    };
    var toggleDaySelection = function (scheduleId, day) {
        var updatedSchedules = schedules.map(function (schedule) {
            if (schedule.id === scheduleId) {
                var newDays = schedule.days.includes(day)
                    ? schedule.days.filter(function (d) { return d !== day; })
                    : __spreadArray(__spreadArray([], schedule.days, true), [day], false);
                return __assign(__assign({}, schedule), { days: newDays });
            }
            return schedule;
        });
        setSchedules(updatedSchedules);
    };
    var handleTimeChange = function (id, type, time) {
        setSchedules(schedules.map(function (schedule) {
            if (schedule.id === id) {
                if (type === "start") {
                    return __assign(__assign({}, schedule), { start: time || "00:00" });
                }
                else {
                    return __assign(__assign({}, schedule), { end: time || "00:00" });
                }
            }
            return schedule;
        }));
    };
    var setActiveStartOrEndForEvent = (0, react_1.useCallback)(function (fromOrTo, dateTimeString) {
        if (fromOrTo === "start") {
            if (dateTimeString === "")
                setEventStart("");
            else
                setEventStart(dateTimeString);
        }
        else {
            if (dateTimeString === "")
                setEventEnd("");
            else
                setEventEnd(dateTimeString);
        }
    }, []);
    var handlePresentationSelected = function (presentation) {
        setSelectedPresentation(presentation);
        setShowAddPresentationModal(false);
    };
    var handleGoBack = function () {
        setShowAddPresentationModal(false);
    };
    var handleRemovePresentation = function () {
        setSelectedPresentation(null);
    };
    var openAddPresentationModal = function () {
        setShowAddPresentationModal(true);
    };
    var handleClose = function () {
        toggle();
        resetForm();
    };
    var handleCreateEvent = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var eventData, error_1, errorObj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!(eventName !== "" && isValidDateRange)) return [3 /*break*/, 7];
                    eventData = {
                        title: eventName,
                        active: eventActive,
                        time_schedule: schedules,
                        presentation_id: selectedPresentation === null || selectedPresentation === void 0 ? void 0 : selectedPresentation.presentation_id,
                        presentation_version_id: selectedPresentation === null || selectedPresentation === void 0 ? void 0 : selectedPresentation.presentation_version_id,
                        presentation_name: selectedPresentation === null || selectedPresentation === void 0 ? void 0 : selectedPresentation.presentation_title
                    };
                    if (eventStart) {
                        eventData.start = Number(eventStart);
                    }
                    else {
                        eventData.start = null;
                    }
                    if (eventEnd) {
                        eventData.end = Number(eventEnd);
                    }
                    else {
                        eventData.end = null;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!(modalMode === "new")) return [3 /*break*/, 3];
                    return [4 /*yield*/, ApiManager_1.default.createEvent(eventData)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(modalMode === "edit" && existingEventData)) return [3 /*break*/, 5];
                    return [4 /*yield*/, ApiManager_1.default.updateEvent(Number(existingEventData.id), eventData)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    handleClose();
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    errorObj = new Error(error_1.message);
                    logger.error(errorObj.message, errorObj);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var body = (react_1.default.createElement("div", { className: EventManagement_module_css_1.default.body, "data-cy": "newEventModal" },
        react_1.default.createElement("div", { className: EventManagement_module_css_1.default["form-group"] },
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["form-group-item"] },
                react_1.default.createElement("label", { htmlFor: "title" }, t("Title")),
                react_1.default.createElement(q_play_components_1.Input, { type: "text", id: "title", name: "title", value: eventName, onChange: function (e) { return setEventName(e.target.value); }, className: EventManagement_module_css_1.default["name-input"], style: { borderRadius: "4px" }, "data-cy": "eventTitleInput" })),
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["form-group-item"] },
                react_1.default.createElement("span", null, t("Activate")),
                react_1.default.createElement("div", { style: { marginTop: "5px" } },
                    react_1.default.createElement(q_play_components_1.Switch, { checked: eventActive, onChange: function () { return setEventActive(!eventActive); }, "data-cy": "eventActiveSwitch" })))),
        react_1.default.createElement("div", { className: EventManagement_module_css_1.default["second-form-group"] },
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["form-group-item"] },
                react_1.default.createElement("label", { htmlFor: "start" }, t("Start")),
                react_1.default.createElement(DateTimePicker_1.default, { timePicker: true, onSelect: function (dateTimeString) { return setActiveStartOrEndForEvent("start", dateTimeString); }, dateTimeString: eventStart, showClockIcon: true, style: { paddingLeft: "1em" } })),
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["form-group-item"] },
                react_1.default.createElement("label", { htmlFor: "end" }, t("End")),
                react_1.default.createElement(DateTimePicker_1.default, { timePicker: true, onSelect: function (dateTimeString) { return setActiveStartOrEndForEvent("end", dateTimeString); }, dateTimeString: eventEnd, showClockIcon: true, style: { paddingLeft: "1em" } }))),
        !selectedPresentation && (react_1.default.createElement("div", { className: EventManagement_module_css_1.default["add-presentation-section"] },
            react_1.default.createElement(q_play_components_1.Button, { text: t("Add presentation"), variant: "secondary", style: {
                    fontSize: "11px",
                    width: "111px",
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }, dataCy: "addPresentationButton", onClick: openAddPresentationModal }),
            react_1.default.createElement("span", null, t("No Presentations Attached")))),
        selectedPresentation && (react_1.default.createElement("div", { style: { marginTop: "30px", marginBottom: "30px" } },
            react_1.default.createElement("span", null,
                t("Selected presentation"),
                ":"),
            react_1.default.createElement("div", { key: selectedPresentation.presentation_id, className: EventManagement_module_css_1.default["attached-presentation-section"], "data-cy": "selectedPresentationSpan" },
                selectedPresentation.presentation_title,
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan, className: EventManagement_module_css_1.default["trash-icon"], style: { marginBottom: "5px" }, onClick: handleRemovePresentation })))),
        react_1.default.createElement("span", { style: { marginTop: "15px", marginBottom: "15px" } }, t("Time Schedule")),
        react_1.default.createElement("div", { className: "".concat(EventManagement_module_css_1.default["time-schedule-container"], " ns-font-family-bold"), style: { color: "var(--info-color)" } },
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["time-container"], style: { display: "flex" } },
                react_1.default.createElement("span", { style: { width: "35%" } }, t("Start time")),
                react_1.default.createElement("span", null, t("End time"))),
            react_1.default.createElement("div", { className: EventManagement_module_css_1.default["days-container"] },
                react_1.default.createElement("span", null, t("Days")))),
        react_1.default.createElement("div", { className: EventManagement_module_css_1.default["scrollable-schedule-container"] },
            schedules.map(function (schedule) { return (react_1.default.createElement("div", { key: schedule.id, className: EventManagement_module_css_1.default["new-time-schedule-container"] },
                react_1.default.createElement("div", { className: EventManagement_module_css_1.default["new-time-container"] },
                    react_1.default.createElement("div", { style: { marginLeft: "-9px" } },
                        react_1.default.createElement(TimeSelector_1.default, { schedule: schedule, type: "start", onTimeChange: handleTimeChange })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(TimeSelector_1.default, { schedule: schedule, type: "end", onTimeChange: handleTimeChange }))),
                react_1.default.createElement("div", { className: EventManagement_module_css_1.default["new-days-container"] },
                    days.map(function (day) { return (react_1.default.createElement(q_play_components_1.Button, { key: day.id, variant: "empty", style: {
                            backgroundColor: schedule.days.includes(day.id) ? "var(--info-color)" : "var(--hover-color)",
                            color: schedule.days.includes(day.id) ? "var(--secondary-color)" : "var(--info-color)",
                            height: "35px",
                            width: "35px"
                        }, size: "small", text: day.initial, onClick: function () { return toggleDaySelection(schedule.id, day.id); }, dataCy: "day-button-".concat(day.id) })); }),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan, className: EventManagement_module_css_1.default["trash-icon"], onClick: function () { return handleRemoveRow(schedule.id); } })))); }),
            react_1.default.createElement(q_play_components_1.Button, { text: t("+"), variant: "primary", style: { width: "100%", marginTop: "15px" }, onClick: handleAddRow, dataCy: 'addNewRowButton' }))));
    var footer = (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
        !isValidDateRange && (react_1.default.createElement("span", { style: { color: "var(--error-color)", marginRight: "190px" } }, t("Start time cannot be higher or equal to end time"))),
        react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), onClick: handleCreateEvent, disabled: !eventName || !isValidDateRange, "data-cy": "saveEventButton" })));
    var CustomHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "20px" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, modalMode === "edit" ? t("Update event") : t("New event"))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: handleClose, centered: true, header: CustomHeader, body: body, footer: footer, dialogClassName: "".concat(EventManagement_module_css_1.default["new-event-modal"], " ").concat(showAddPresentationModal ? EventManagement_module_css_1.default.hidden : "") }),
        react_1.default.createElement(AddPresentationModal_1.default, { isShown: showAddPresentationModal, toggle: function () { return setShowAddPresentationModal(false); }, type: types_1.ResourceType.EVENT, event: existingEventData, onBack: handleGoBack, onPresentationsSelected: handlePresentationSelected })));
};
exports.default = NewEventModal;
